import { TickRoundelIcon, AlertLowIcon, AlertMediumIcon, AlertHighIcon, } from '../../assets/svgs';
const INFORMATION_ICONS = {
    advisory: AlertMediumIcon,
    informative: AlertLowIcon,
    warning: AlertHighIcon,
    success: TickRoundelIcon,
};
export default INFORMATION_ICONS;
//# sourceMappingURL=modal-icons.js.map